import { Box, CircularProgress } from "@mui/material";
import { Navigate } from "react-router";
import { PuckRenderer } from "src/components/Puck/PuckRenderer";
import { URLHandler } from "src/services/URLHandler";
import { useGetPuckPageByUrl } from "src/api/client-api/cms/useGetPuckPageByUrl";
import { useApplicationParameters } from "src/api/client-api/appParams";
import { useUserContext } from "src/context/User/useUserContext";
import { getQuestionnaireNavigationUrl } from "src/utils/questionnaire";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { MainContentLayout } from "src/components/Layout/MainContentLayout";

export const HomeSwitch = () => {
    const { selectedCompany } = useUserContext();
    const { currentCampaign } = useFoodpilotContext();
    const { isFeatureActivated } = useApplicationParameters();

    const isPuckHomepageEnabled = isFeatureActivated("FS-cms-enabled");

    const {
        page: homePage,
        isFetched: isHomeFetched,
        isError: isHomeError,
    } = useGetPuckPageByUrl({
        url: "/",
        selectedCompanyId: selectedCompany?.id,
        entityType: selectedCompany?.id ? "company" : undefined,
        enabled: isPuckHomepageEnabled,
    });

    if (isPuckHomepageEnabled) {
        if (!isHomeFetched) {
            return (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "50vh",
                    }}
                >
                    <CircularProgress />
                </Box>
            );
        }

        if (!isHomeError && homePage) {
            const puckContent = homePage?.content ? JSON.parse(homePage.content) : {};
            return (
                <MainContentLayout>
                    <PuckRenderer data={puckContent} isLoading={!isHomeFetched} />
                </MainContentLayout>
            );
        }
    }

    if (selectedCompany === null) {
        return <Navigate to={URLHandler.login.noCompany()} replace />;
    }

    if (isFeatureActivated("FS-entity-companies")) {
        return currentCampaign?.id ?
                <Navigate to={getQuestionnaireNavigationUrl(selectedCompany, currentCampaign.id)} replace />
            :   <Navigate to={URLHandler.company.questionnaire(selectedCompany.id)} replace />;
    }

    if (isFeatureActivated("FS-entity-ingredients") && isFeatureActivated("FS-entity-products")) {
        return selectedCompany.isProvider ?
                <Navigate to={URLHandler.ingredient.list(selectedCompany.id)} replace />
            :   <Navigate to={URLHandler.product.list(selectedCompany.id)} replace />;
    }

    if (isFeatureActivated("FS-entity-products")) {
        return <Navigate to={URLHandler.product.list(selectedCompany.id)} replace />;
    }

    if (isFeatureActivated("FS-entity-ingredients")) {
        return <Navigate to={URLHandler.ingredient.list(selectedCompany.id)} replace />;
    }

    return <Navigate to={URLHandler.settings.configuration()} replace />;
};
